import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("litecoin",i`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            static
        >
            <g clip-path="url(#clip0_4874_1077)">
                <path
                    d="M12.0002 22.7015C17.9104 22.7015 22.7015 17.9104 22.7015 12.0002C22.7015 6.08999 17.9104 1.29883 12.0002 1.29883C6.08999 1.29883 1.29883 6.08999 1.29883 12.0002C1.29883 17.9104 6.08999 22.7015 12.0002 22.7015Z"
                    fill="white"
                />
                <path
                    d="M12 -0.00195312C5.37284 -0.00195312 0 5.37371 0 11.9999C0 18.6262 5.37284 23.9999 12 23.9999C18.6272 23.9999 24.0005 18.6276 24.0005 11.9999C24.0193 5.39163 18.6781 0.0192666 12.0703 -0.00195312H12ZM12.2037 12.405L10.9541 16.6178H17.6369C17.7263 16.6146 17.8132 16.6471 17.8787 16.708C17.9441 16.7689 17.9827 16.8534 17.9859 16.9427V17.0531L17.4049 19.0604C17.3793 19.1553 17.3222 19.2386 17.2431 19.2966C17.1639 19.3547 17.0673 19.3842 16.9692 19.3802H6.74128L8.45536 13.54L6.53757 14.121L6.97375 12.7846L8.89107 12.2032L11.3031 4.00952C11.3295 3.91523 11.3868 3.83252 11.4658 3.77457C11.5448 3.71663 11.6409 3.68679 11.7388 3.68981H14.3247C14.4141 3.68676 14.501 3.71932 14.5664 3.78033C14.6317 3.84135 14.6701 3.92583 14.6732 4.01518V4.12599L12.6394 11.0413L14.5572 10.4599L14.1512 11.8547L12.2037 12.405Z"
                    fill="#345D9D"
                />
            </g>
            <defs>
                <clipPath id="clip0_4874_1077">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Litecoin};
